import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Prospects from "@/pages/Prospects";
import Campaigns from "@/pages/Campaigns";
import Inbox from "@/pages/Inbox";
import Appointments from "@/pages/Appointments";
import Territory from "@/pages/Territory";
import Team from "@/pages/Team";
import Rules from "@/pages/Rules";
import Sessions from "@/pages/Sessions";
import BookingLink from "@/pages/BookingLink";
import SettingsPage from "@/pages/Settings";
import PublicBooking from "@/pages/PublicBooking";
import Login from "@/pages/Login";
import { AuthProvider, useAuth } from "@/lib/team";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-screen grid place-items-center text-sm text-neutral-500">Loading…</div>;
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/book/:slug" element={<PublicBooking />} />
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/prospects" element={<Prospects />} />
        <Route path="/territory" element={<Territory />} />
        <Route path="/campaigns" element={<Campaigns />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/appointments" element={<Appointments />} />
        <Route path="/team" element={<Team />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/sessions" element={<Sessions />} />
        <Route path="/booking-link" element={<BookingLink />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
